<div class="tabs">
  <button
    *ngFor="let tab of tabs; let i = index"
    class="tab"
    [ngClass]="{ selected: selectedTabIndex === i }"
    i2gTrackable
    [trackingObject]="tab.trackingObject"
    [trackingAction]="tab.trackingAction"
    (click)="onTabSelected(tab, i)"
  >
    {{ tab.label }}
  </button>
</div>
